<template>
    <div>
        <div class="text-center text-white">
            <h1 class="text-3xl">
                Liquidity Flow
            </h1>
            <h2 class="text-5xl font-semibold">
                Get early access
            </h2>
        </div>
        <div class=" relative lg:grid lg:grid-cols-10 my-10">
            <div class="max-w-lg mx-auto lg:max-w-none lg:mx-0 lg:col-start-4 lg:col-end-8 lg:row-start-1 lg:row-end-4">
                <div class="relative z-10 bg-white rounded-lg shadow-xl">
                    <div>
                        <div class="pointer-events-none absolute inset-0 rounded-lg border-2 border-blue-600"></div>
                        <div class="absolute inset-x-0 top-0 transform translate-y-px">
                            <div class="flex justify-center transform -translate-y-1/2">
                                <span class="inline-flex rounded-full bg-blue-600 px-4 py-1 text-sm leading-5 font-semibold tracking-wider uppercase text-white">
                                    Most value
                                </span>
                            </div>
                        </div>
                        <div class="rounded-t-lg px-6 pt-12 pb-10">
                            <div>
                                <!-- <p class="text-center text-lg leading-7 font-semibold font-display text-blue-700 uppercase tracking-widest">
                                    Bundle
                                </p> -->
                                <h2 class="mt-2 text-center text-3xl leading-9 font-semibold font-display text-gray-900 sm:-mx-6">
                                    Business
                                </h2>
                                <div class="mt-4 flex items-center justify-center font-display">
                                    <!-- <span class="-ml-8 text-right text-2xl leading-8 font-semibold text-gray-700 tracking-wide line-through sm:text-3xl sm:leading-9">
                                        $298
                                    </span> -->
                                    <span class="px-3 flex items-start text-6xl leading-none tracking-tight font-medium text-gray-900 sm:text-7xl">
                                        <!-- <span class="mt-2 mr-1 text-4xl leading-none sm:text-5xl">
                                            $
                                        </span> -->
                                        <span>
                                            9.90
                                        </span>
                                    </span>
                                    <span class="text-2xl leading-8 font-semibold text-gray-700 tracking-wide sm:text-3xl sm:leading-9">
                                        EUR
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="border-t-1 border-gray-100 rounded-b-lg pt-10 pb-8 px-6 bg-gray-50 sm:px-10 sm:py-10">
                            <ul class="listPricing">
                                <BaseListPricing>
                                    Unlimited payments
                                </BaseListPricing>
                                <BaseListPricing>
                                    Unlimited payment-value
                                </BaseListPricing>
                                <BaseListPricing>
                                    Unlimited recurring payments
                                </BaseListPricing>
                                <BaseListPricing>
                                    Unlimited Email Reminders
                                </BaseListPricing>
                                <BaseListPricing>
                                    180 Day planning horizon
                                </BaseListPricing>
                                <BaseListPricing>
                                    Prefered Email Support
                                </BaseListPricing>
                            </ul>
                            <div class="mt-10">
                                <div class="rounded-lg shadow-md">
                                    <a href="mailto:sales@fstar.at" class="block w-full text-center rounded-lg bg-gray-800 px-6 py-4 text-xl leading-6 font-semibold font-display text-white hover:bg-gray-700 focus:outline-none focus:shadow-outline transition ease-in-out duration-150" target="_blank">
                                        Buy Early Access
                                    </a>
                                </div>
                                <p class="mt-6 text-center text-base leading-6 font-medium text-gray-900">
                                    Buying for your team?
                                    <a href="mailto:sales@fstar.at" class="text-blue-700 font-semibold hover:underline">
                                        Get team quote →
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-6 mx-auto max-w-md lg:m-0 lg:max-w-none lg:col-start-1 lg:col-end-4 lg:row-start-2 lg:row-end-3">
                <div class="h-full flex flex-col bg-white border-gray-100 border-2 lg:border-r-0 rounded-lg shadow-lg overflow-hidden lg:rounded-none lg:rounded-l-lg">
                    <div class="flex-1 flex flex-col ">
                        <div class="px-6 pt-12 pb-10 ">
                            <div>
                                <h2 class="mt-2 text-center text-3xl leading-9 font-semibold font-display text-gray-900">
                                    get to know
                                </h2>
                                <div class="mt-4 flex items-center justify-center font-display">
                                    <span class="px-3 flex items-start text-6xl leading-none tracking-tight font-medium text-gray-900">
                                        <!-- <span class="mt-2 mr-2 text-4xl">
                                            $
                                        </span> -->
                                        <span>
                                            FREE
                                        </span>
                                    </span>
                                    <!-- <span class="text-2xl leading-8 font-semibold text-gray-400 tracking-wide">
                                        EUR
                                    </span> -->
                                </div>
                            </div>
                        </div>
                        <div class="flex-1 flex flex-col justify-between border-t-2 border-gray-100 p-6 bg-gray-50 sm:p-10 lg:p-6 xl:p-10">
                            <ul>
                                <BaseListPricing>
                                    10 payments
                                </BaseListPricing>
                                <BaseListPricing>
                                    3000 payment limit
                                </BaseListPricing>
                                <BaseListPricing>
                                    30 Day planning horizon
                                </BaseListPricing>
                                <BaseListPricing>
                                    Support: FAQs
                                </BaseListPricing>
                            </ul>
                            <div class="mt-8">
                                <div class="rounded-lg shadow-md">
                                    <router-link
                                        to="login"
                                        class="block w-full text-center rounded-lg bg-white px-6 py-3 text-base leading-6 font-semibold font-display text-teal-600 hover:text-blue-700 focus:outline-none focus:shadow-outline transition ease-in-out duration-150" target="_blank">
                                        Signup 100% FREE, <br>no creditcard needed.
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-6 mx-auto max-w-md lg:m-0 lg:max-w-none lg:col-start-8 lg:col-end-11 lg:row-start-2 lg:row-end-3">
                <div class="h-full flex flex-col bg-white border-gray-100 border-2 lg:border-l-0 rounded-lg shadow-lg overflow-hidden lg:rounded-none lg:rounded-r-lg">
                    <div class="flex-1 flex flex-col">
                        <div class="border-blue-400 px-6 pt-12 pb-10">
                            <div>
                                <h2 class="mt-2 text-center text-3xl leading-9 font-semibold font-display text-gray-900">
                                    Private
                                </h2>
                                <div class="mt-4 flex items-center justify-center font-display">
                                    <span class="px-3 flex items-start text-6xl leading-none tracking-tight font-medium text-gray-900">
                                        <!-- <span class="mt-2 mr-2 text-4xl">
                                            EUR
                                        </span> -->
                                        <span>
                                            4.90
                                        </span>
                                    </span>
                                    <span class="text-2xl leading-8 font-semibold text-gray-700 tracking-wide">
                                        EUR
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="flex-1 flex flex-col justify-between border-t-2 border-gray-100 p-6 bg-gray-50 sm:p-10 lg:p-6 xl:p-10">
                            <ul>
                                <BaseListPricing>
                                    30 payments
                                </BaseListPricing>
                                <BaseListPricing>
                                    10000 payment-value
                                </BaseListPricing>
                                <BaseListPricing>
                                    10 recurring payments
                                </BaseListPricing>
                                <BaseListPricing>
                                    Unlimited Email Reminders
                                </BaseListPricing>
                                <BaseListPricing>
                                    90 Day planning horizon
                                </BaseListPricing>
                                <BaseListPricing>
                                    Email Support
                                </BaseListPricing>

                            </ul>
                            <div class="mt-8">
                                <div class="rounded-lg shadow-md">
                                    <!-- https://gum.co/jYnNI -->
                                    <a href="mailto:sales@fstar.at" data-gumroad-single-product="true" class="block w-full text-center rounded-lg bg-white px-6 py-3 text-base leading-6 font-semibold font-display text-teal-600 hover:text-blue-700 focus:outline-none focus:shadow-outline transition ease-in-out duration-150" target="_blank">
                                        Buy Early Access
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaseListPricing from '@/components/Base/BaseListPricing.vue';

export default {
    name: 'Pricing',
    components: {
        BaseListPricing,
    },
};
</script>

<style >
.listPricing li:first-child{
  margin-top: 0rem;
}
</style>
